export function getFileNameFromFilepath(filepath: string): string {
  const splitFilepath = filepath.split('/');
  const fileName = splitFilepath[splitFilepath.length - 1];
  return fileName;
}
